import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { assignRdpToUser, updateRdps } from "../store/actions/rdp";
import { toast } from "react-toastify";
import Select from "react-select";
import { getAllUsers } from "../store/actions/user";
// import { PANEL_TYPES, REMOTE_TYPES, SERVER_TYPES } from "../utills/constant";

import { getAllServerType } from "../store/actions/servertype";
import { getAllDataCenter } from "../store/actions/DataCenter";
import { getAllRemoteControl } from "../store/actions/remoteControl";
import { getAllRemotePanel } from "../store/actions/remotePanel";
import { getAllServer } from "../store/actions/server";
import { MdEdit } from "react-icons/md";
import { LiaTrashRestoreAltSolid } from "react-icons/lia";
import { IoTrashBinOutline } from "react-icons/io5";
import { GrDocumentConfig } from "react-icons/gr";
import { IoPersonAddOutline } from "react-icons/io5";
import { AiOutlineUsergroupAdd } from "react-icons/ai";


const RdpListTab = ({
  userHeader,
  userProducts,
  loading,
  totalCount,
  fetchAllData,
  filter,
  setFilter,
}) => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState(null);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const itemsPerPage = 10;
  const totalItems = totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [value, setValue] = useState(null);
  const [formData, setFormData] = useState({
    Name: "", // Required
    location: "", // Should store a MongoDB ObjectId
    server: "", // Should store a MongoDB ObjectId
    serverType: "", // Should store a MongoDB ObjectId
    remoteType: "", // Should store a MongoDB ObjectId
    pannelType: [], // Array of MongoDB ObjectIds
    serverConf: {
      hostName: "", // Required
      port: "", // Not required
      userName: "", // Required
      password: "", // Required
    },
    serverDesc: {
      ram: "", // Required
      hddtype: "", // Not required
      storage: "", // Required
      backup: "", // Required
    },
    pannelConf: {
      hostName: "", // Required
      userName: "", // Required
      password: "", // Required
    },
    status: "1", // Required, default "1"
  });

  const [serverTypes, setServerTypes] = useState([]);
  const [dataCenters, setDataCenters] = useState([]);
  const [remoteTypes, setRemoteTypes] = useState([]);
  const [panelTypes, setPanelTypes] = useState([]);
  const [servers, setServers] = useState([]);

  const [filteredRemoteTypes, setFilteredRemoteTypes] = useState([]);
  const [filteredPanelTypes, setFilteredPanelTypes] = useState([]);

  const [showConfigModal, setShowConfigModal] = useState(false);
  const [showAssignClientModal, setShowAssignClientModal] = useState(false);
  const [showAssignPOCModal, setShowAssignPOCModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Call APIs on mount
  useEffect(() => {
    dispatch(getAllServerType());
    dispatch(getAllDataCenter());
    dispatch(getAllRemoteControl());
    dispatch(getAllRemotePanel());
    dispatch(getAllServer());
  }, [dispatch]);

  // Access data from Redux store
  const serverTypesLst = useSelector((state) => state.serverType);
  const dataCentersList = useSelector((state) => state.DataCenter);
  const remoteControls = useSelector((state) => state.RemoteControl);
  const remotePanels = useSelector((state) => state.RemotePanel);
  const serverlist = useSelector((state) => state.server);

  useEffect(() => {
    setServerTypes(
      Array.isArray(serverTypesLst?.servers) ? serverTypesLst.servers : []
    );
  }, [serverTypesLst]);

  useEffect(() => {
    setDataCenters(
      Array.isArray(dataCentersList?.servers) ? dataCentersList.servers : []
    );
  }, [dataCentersList]);

  useEffect(() => {
    setRemoteTypes(
      Array.isArray(remoteControls?.servers) ? remoteControls.servers : []
    );
  }, [remoteControls]);

  useEffect(() => {
    setPanelTypes(
      Array.isArray(remotePanels?.servers) ? remotePanels.servers : []
    );
  }, [remotePanels]);

  useEffect(() => {
    setServers(Array.isArray(serverlist?.servers) ? serverlist.servers : []);
  }, [serverlist]);

  console.log("serverTypesLst", serverTypesLst.servers);
  console.log("dataCentersList", dataCentersList.servers);
  console.log("remoteControls", remoteControls.servers);
  console.log("remotePanels", remotePanels.servers);

  //redux logic
  useEffect(() => {
    if (formData.serverType) {
      setFilteredRemoteTypes(
        remoteTypes.filter(
          (item) =>
            item.serverType && item.serverType._id === formData.serverType
        )
      );
      setFilteredPanelTypes(
        panelTypes.filter(
          (item) =>
            item.serverType && item.serverType._id === formData.serverType
        )
      );

      // Reset remote/panel type when server changes
      setFormData((prev) => ({
        ...prev,
        remoteType: "",
        pannelType: "",
      }));
    }
  }, [formData.serverType, remoteTypes, panelTypes]);
  const users = useSelector((state) => state.users);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setFilter({ ...filter, page: page.toString() });
    }
  };

  const currentItems = userProducts;
  const toggleModalEditClose = () => {
    setIsModalEdit(false);
    setCurrentData(null);
  };
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  // console.log(userProducts);

  const toggleModalEdit = (user) => {
    const transformedData = {
      Name: user.Name || "",
      location: user.location?._id || user.location || "",
      server: user.server?._id || user.server || "",
      serverType: user.serverType?._id || user.serverType || "",
      remoteType: user.remoteType?._id || user.remoteType || "",
      pannelType: Array.isArray(user.pannelType)
        ? user.pannelType.map((p) => p?._id || p)
        : [],

      serverConf: {
        hostName: user.serverConf?.hostName || "",
        port: user.serverConf?.port || "",
        userName: user.serverConf?.userName || "",
        password: user.serverConf?.password || "",
      },

      serverDesc: {
        ram: user.serverDesc?.ram || "",
        hddtype: user.serverDesc?.hddtype || "",
        storage: user.serverDesc?.storage || "",
        backup: user.serverDesc?.backup || "",
      },

      pannelConf: {
        hostName: user.pannelConf?.hostName || "",
        userName: user.pannelConf?.userName || "",
        password: user.pannelConf?.password || "",
      },

      status: user.status || "1",
    };

    setFormData(transformedData);
    setCurrentData(user);
    setIsModalEdit(true);
  };

  useEffect(() => {
    dispatch(getAllUsers());
  }, [dispatch]);

  const handleEditUser = (e) => {
    e.preventDefault();
    dispatch(
      updateRdps({
        id: currentData._id,
        data: formData,
      })
    );
    toast.success("RDP Updated Successfully", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
      onClose: () => {
        fetchAllData();
      },
    });
    setIsModalEdit(false);
    setCurrentData(null);
  };
  const handleBlockUser = ({ id, status }) => {
    dispatch(
      updateRdps({
        id: id,
        data: {
          status: status,
        },
      })
    );
    if (status === "1") {
      toast.success("RDP Blocked successfully!", {
        position: "top-right", // Use string instead of POSITION.TOP_RIGHT
        autoClose: 600,
        onClose: () => {
          fetchAllData();
        },
      });
    } else if (status === "0") {
      toast.success("RDP Unblocked successfully", {
        position: "top-right", // Use string instead of POSITION.TOP_RIGHT
        autoClose: 600,
        onClose: () => {
          fetchAllData();
        },
      });
    }
  };

  // Open the modal
  const handleOpenModal = (value) => {
    setCurrentData(value);
    setIsModalOpen(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setCurrentData(null);
    setSelectedOptions([]);
    setIsModalOpen(false);
  };

  // Assign selected options
  const handleAssign = () => {
    let userList = value.map((option) => option.value);
    dispatch(
      assignRdpToUser({
        userList: userList,
        rdpId: currentData._id,
      })
    );
    setCurrentData(null);
    setSelectedOptions([]);
    setIsModalOpen(false);
    toast.success("RDP Assigned successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
    });
  };

  const options =
    users?.usersList &&
    users?.usersList.map((user) => ({
      value: user._id,
      label: `${user.username} - ${user.email}`,
    }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNestedChange = (e, section) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: value,
      },
    }));
  };

  const handleOpenConfig = (product) => {
    setSelectedProduct(product);
    setShowConfigModal(true);
  };

  const handleOpenAssignClient = (product) => {
    setSelectedProduct(product);
    setShowAssignClientModal(true);
  };

  const handleOpenAssignPOC = (product) => {
    setSelectedProduct(product);
    setShowAssignPOCModal(true);
  };

  return (
    <div className="relative bg-card overflow-x-auto shadow-md sm:rounded-lg m-1">
      {loading ? (
        <div className="text-center text-gray-500">Loading...</div>
      ) : totalItems === 0 ? (
        <div className="text-center text-gray-500">No products found</div>
      ) : (
        <>
          <table className="w-full text-sm text-left rtl:text-right bg-card  text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-text uppercase bg-[#02256d] text-white">
              <tr>
                {/* <th scope="col" className="p-4">
                  <div className="flex items-center">
                    <input
                      id="checkbox-all-search"
                      type="checkbox"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                      aria-label="Select all products"
                    />
                  </div>
                </th> */}
                {userHeader.map((header, index) => (
                  <th key={index} scope="col" className="px-6 py-3">
                    {header.label || header.key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentItems.map((product, index) => (
                <tr
                  key={index}
                  className="bg-card border-b  dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium  whitespace-nowrap "
                  >
                    {product?.Name}
                  </th>
                  <td className="px-6 py-4">{product?.location?.name}</td>
                  <td className="px-6 py-4">{product?.serverType?.name}</td>
                  <td className="px-6 py-4">{product?.remoteType?.name}</td>
                  <td className="px-6 py-4">
                    {product?.pannelType?.map((panel) => panel.name).join(",")}
                  </td>
                  <td className="px-6 py-4">
                    {product?.serverConf?.hostName}
                    {product?.serverConf?.port
                      ? ": " + product?.serverConf?.port
                      : ""}
                    {/* <br />
                    {product?.serverConf?.userName}
                    <br />
                    {product?.serverConf?.password} */}
                  </td>
                  <td className="px-6 py-4">
                    {product?.pannelConf?.hostName}
                    {/* <br />
                    {product?.pannelConf?.userName}
                    <br />
                    {product?.pannelConf?.password} */}
                  </td>
                  <td className="px-6 py-4">
                    {product?.status === "1" ? "Active" : "InActive"}
                  </td>
                  <td className="px-6 py-4 gap-4 flex">
                    <button
                      onClick={() => toggleModalEdit(product)}
                      title="Edit"
                      className="font-medium text-blue-600  border  border-blue-600  px-2 rounded-lg hover:text-white hover:bg-blue-600"
                    >
                      <MdEdit className="text-lg" />
                    </button>
                    {currentData && isModalEdit && (
                      <div
                        id="crud-modal"
                        className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-900 bg-opacity-10"
                      >
                        <div className="relative p-4 w-full max-w-4xl h-auto">
                          {/* Modal Content */}
                          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                            {/* Modal Header */}
                            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                Edit server list
                              </h3>
                              <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                onClick={toggleModalEditClose} // Correct function for toggling modal
                              >
                                <IoClose className="w-5 h-5" />
                              </button>
                            </div>

                            {/* Modal Body */}
                            {/* By Rajnish,  */}
                            <form
                              className="p-4 md:p-5 max-h-[80vh] overflow-y-auto"
                              onSubmit={handleEditUser}
                            >
                              <div className="grid gap-4 mb-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                                {Object.keys(formData).map((key) => {
                                  if (
                                    typeof formData[key] === "object" &&
                                    formData[key] !== null
                                  ) {
                                    return Object.keys(formData[key])?.map(
                                      (subKey) => (
                                        <div
                                          key={`${key}-${subKey}`}
                                          className="col-span-2 md:col-span-1"
                                        >
                                          <label
                                            htmlFor={`${key}-${subKey}`}
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                          >
                                            {`${key} ${subKey}`}
                                          </label>
                                          <input
                                            type="text"
                                            id={`${key}-${subKey}`}
                                            name={subKey}
                                            value={formData[key][subKey]}
                                            onChange={(e) =>
                                              setFormData((prev) => ({
                                                ...prev,
                                                [key]: {
                                                  ...prev[key],
                                                  [subKey]: e.target.value,
                                                },
                                              }))
                                            }
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                            required
                                          />
                                        </div>
                                      )
                                    );
                                  } else if (
                                    key === "serverType" ||
                                    key === "remoteType" ||
                                    key === "pannelType" ||
                                    key === "location" ||
                                    key === "server"
                                  ) {
                                    const options =
                                      key === "serverType"
                                        ? serverTypes
                                        : key === "remoteType"
                                        ? filteredRemoteTypes
                                        : key === "location"
                                        ? dataCenters
                                        : key === "server"
                                        ? servers
                                        : filteredPanelTypes;

                                    return (
                                      <div
                                        key={key}
                                        className="col-span-2 md:col-span-1"
                                      >
                                        <label
                                          htmlFor={key}
                                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                        >
                                          {key}
                                        </label>
                                        <select
                                          id={key}
                                          name={key}
                                          value={formData[key]}
                                          onChange={handleChange}
                                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                          required
                                        >
                                          <option value="">
                                            Select an option
                                          </option>
                                          {options
                                            .filter(
                                              (items) => items.status !== "0"
                                            )
                                            .map((item) => (
                                              <option
                                                key={item._id}
                                                value={item._id}
                                              >
                                                {item.name}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                    );
                                  } else {
                                    return (
                                      <div
                                        key={key}
                                        className="col-span-2 md:col-span-1"
                                      >
                                        <label
                                          htmlFor={key}
                                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                        >
                                          {key}
                                        </label>
                                        <input
                                          type="text"
                                          id={key}
                                          name={key}
                                          value={formData[key]}
                                          onChange={handleChange}
                                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                          required
                                        />
                                      </div>
                                    );
                                  }
                                })}
                              </div>
                              <button
                                type="submit"
                                className="w-full justify-center text-white inline-flex items-center bg-[#02256d] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700"
                              >
                                Save
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    )}
                    {product?.status === "1" ? (
                      <button
                        onClick={() =>
                          handleBlockUser({ id: product._id, status: "0" })
                        }
                        title="Block"
                        className="text-red-600 border border-red-600 px-2 py-1 rounded-lg hover:text-white hover:bg-red-600 flex items-center justify-center"
                      >
                        <IoTrashBinOutline className="text-lg" />
                      </button>
                    ) : (
                      <button
                        onClick={() =>
                          handleBlockUser({ id: product._id, status: "1" })
                        }
                        title="Unblock"
                        className="text-green-600 border border-green-600 px-2 py-1 rounded-lg hover:text-white hover:bg-green-600 flex items-center justify-center"
                      >
                        <LiaTrashRestoreAltSolid className="text-lg" />
                      </button>
                    )}
                    <button
                      onClick={() => handleOpenConfig(product)}
                      title="Configration"
                      className="text-purple-600 border border-purple-600 px-2 py-1 rounded-lg hover:text-white hover:bg-purple-600 flex items-center justify-center"
                    >
                      <GrDocumentConfig className="text-lg" />
                    </button>
                    <button
                      onClick={() => handleOpenAssignClient(product)}
                      title="Assign to Client"
                      className="text-teal-600 border border-teal-600 px-2 py-1 rounded-lg hover:text-white hover:bg-teal-600 flex items-center justify-center"
                    >
                      <AiOutlineUsergroupAdd className="text-lg" />
                    </button>

                    <button
                      onClick={() => handleOpenAssignPOC(product)}
                      title="Assign to POC"
                      className="text-pink-600 border border-pink-600 px-2 py-1 rounded-lg hover:text-white hover:bg-pink-600 flex items-center justify-center"
                    >
                      <IoPersonAddOutline className="text-lg" />
                    </button>

                    {/* Modal */}

                    {showConfigModal && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                        <div className="bg-white rounded-lg p-6 w-[400px]">
                          <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold text-gray-800">
                              Configuration
                            </h2>
                            <button onClick={() => setShowConfigModal(false)}>
                              <IoClose size={20} />
                            </button>
                          </div>
                          <ul className="text-sm text-gray-700 space-y-2">
                            <li>
                              <strong>Port:</strong> 3389
                            </li>
                            <li>
                              <strong>RAM:</strong> 16 GB
                            </li>
                            <li>
                              <strong>Storage:</strong> 512 GB SSD
                            </li>
                            <li>
                              <strong>Core:</strong> 4 Core
                            </li>
                            <li>
                              <strong>Pricing:</strong> ₹1500/month
                            </li>
                            <li>
                              <strong>Bandwidth:</strong> 1 Gbps
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}

                    {showAssignClientModal && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                        <div className="bg-white rounded-lg p-6 w-[400px]">
                          <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold text-gray-800">
                              Select Client
                            </h2>
                            <button
                              onClick={() => setShowAssignClientModal(false)}
                            >
                              <IoClose size={20} />
                            </button>
                          </div>
                          <select className="w-full border p-2 rounded">
                            <option>Select a client</option>
                            <option value="client1">Client One</option>
                            <option value="client2">Client Two</option>
                            <option value="client3">Client Three</option>
                          </select>
                          <button className="w-full mt-4 bg-teal-600 text-white py-2 rounded hover:bg-teal-700">
                            Assign
                          </button>
                        </div>
                      </div>
                    )}

                    {showAssignPOCModal && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                        <div className="bg-white rounded-lg p-6 w-[400px]">
                          <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold text-gray-800">
                              Select POC
                            </h2>
                            <button
                              onClick={() => setShowAssignPOCModal(false)}
                            >
                              <IoClose size={20} />
                            </button>
                          </div>
                          <select className="w-full border p-2 rounded">
                            <option>Select a POC</option>
                            <option value="poc1">POC One</option>
                            <option value="poc2">POC Two</option>
                          </select>
                          <button className="w-full mt-4 bg-pink-600 text-white py-2 rounded hover:bg-pink-700">
                            Assign
                          </button>
                        </div>
                      </div>
                    )}

                    {isModalOpen && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-900 bg-opacity-10">
                        <div className="bg-card p-4 rounded-lg shadow-lg w-96">
                          {/* Modal Header */}
                          <div className="flex items-center justify-between p-0 border-b my-2  rounded-t dark:border-gray-600">
                            <h3 className="text-lg font-medium text-text">
                              select user to assign
                            </h3>
                            <button
                              type="button"
                              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                              onClick={handleCloseModal}
                            >
                              <IoClose className="w-5 h-5" />
                            </button>
                          </div>

                          {/* Modal Content with checkboxes */}
                          <Select
                            options={options}
                            defaultValue={value}
                            placeholder="Select a user"
                            onChange={setValue}
                            isMulti
                          />

                          {/* Modal Footer with buttons */}
                          <div className="flex justify-between mt-4">
                            <button
                              onClick={handleCloseModal}
                              className="px-4 py-1 bg-gray-300 rounded-md"
                            >
                              Close
                            </button>
                            <button
                              onClick={handleAssign}
                              className="px-4 py-1 bg-blue-600 text-white rounded-md"
                            >
                              Assign
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <nav
            className="flex items-center justify-between m-4"
            aria-label="Table navigation"
          >
            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
              Showing{" "}
              <span className="font-semibold text-text">
                {(currentPage - 1) * itemsPerPage + 1} -{" "}
                {Math.min(currentPage * itemsPerPage, totalItems)}
              </span>{" "}
              of <span className="font-semibold text-text">{totalItems}</span>
            </span>
            <ul className="inline-flex -space-x-px text-sm h-8">
              {/* Previous Button */}
              <li>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700"
                  aria-disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>

              {/* First Page */}
              <li>
                <button
                  onClick={() => handlePageChange(1)}
                  className={`flex items-center justify-center px-3 h-8 ${
                    currentPage === 1
                      ? "text-white bg-[#02256d]"
                      : "text-gray-500 bg-white"
                  } border border-gray-300 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700`}
                >
                  1
                </button>
              </li>

              {/* Second Page */}
              {totalPages > 1 && (
                <li>
                  <button
                    onClick={() => handlePageChange(2)}
                    className={`flex items-center justify-center px-3 h-8 ${
                      currentPage === 2
                        ? "text-white bg-blue-500"
                        : "text-gray-500 bg-white"
                    } border border-gray-300 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700`}
                  >
                    2
                  </button>
                </li>
              )}

              {/* Ellipsis for skipped pages */}
              {currentPage > 3 && <span className="px-2">...</span>}

              {/* Last two pages */}
              {currentPage < totalPages - 2 && (
                <span className="px-2">...</span>
              )}
              {totalPages > 2 && (
                <li>
                  <button
                    onClick={() => handlePageChange(totalPages - 1)}
                    className={`flex items-center justify-center px-3 h-8 ${
                      currentPage === totalPages - 1
                        ? "text-white bg-blue-500"
                        : "text-gray-500 bg-white"
                    } border border-gray-300 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700`}
                  >
                    {totalPages - 1}
                  </button>
                </li>
              )}
              {totalPages > 1 && (
                <li>
                  <button
                    onClick={() => handlePageChange(totalPages)}
                    className={`flex items-center justify-center px-3 h-8 ${
                      currentPage === totalPages
                        ? "text-white bg-blue-500"
                        : "text-gray-500 bg-white"
                    } border border-gray-300 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700`}
                  >
                    {totalPages}
                  </button>
                </li>
              )}

              {/* Next Button */}
              <li>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700"
                  aria-disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </>
      )}
    </div>
  );
};

export default RdpListTab;
